import { render, staticRenderFns } from "./NewEmployer.vue?vue&type=template&id=23497363"
import script from "./NewEmployer.vue?vue&type=script&lang=ts"
export * from "./NewEmployer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports